const translations = {
    buttonText: 'Delete'
};

export default translations;
